<div class="toolbar-section main-toolbar"
  [class.has-additional-toolbar]="zoomParametersViewModel.showSelectionsFilterOptions">
  <div class="toolbar-control-content">
    <div class="horizontal-container">
      <div class="root-container">
        <div class="inline-command-bar">
          <div class="action-list-control-container">
            <div class="horizontal-flex-container rounded-actions">

              <!-- Toggle filter with populated operator -->
              <div class="command-bar-button-container">
                <nts-text-button [class.active]="zoomParametersViewModel.showFilterWithPopulatedOperator"
                  [title]="zoomParametersViewModel.filterWithPopulatedOperatorButtonTitle" icon="task-list"
                  (onClicked)="zoomParametersViewModel.toggleFilterWithPopulatedOperator()">
                </nts-text-button>
              </div>

              <!-- Toggle selection in filter -->
              <div class="command-bar-button-container">
                <nts-text-button [class.active]="zoomParametersViewModel.showSelectionsFilterOptions"
                  [title]="zoomParametersViewModel.selectionsFiltersOptionsButtonTitle" icon="eye-empty"
                  (onClicked)="zoomParametersViewModel.toggleSelectionsFilterOptions()">
                </nts-text-button>
              </div>

              <!-- Toggle advanced command -->
              <div class="command-bar-button-container">
                <nts-text-button [class.active]="zoomParametersViewModel.showAdvancedFiltersOptions"
                  [title]="zoomParametersViewModel.advancedButtonTitle" icon="fx-rounded"
                (onClicked)="zoomParametersViewModel.toggleAdvancedFilters()"></nts-text-button>
              </div>

              <!-- Toggle sorting -->
              <div class="command-bar-button-container">
                <nts-text-button [class.active]="zoomParametersViewModel.showSortingGroups"
                  [title]="zoomParametersViewModel.sortingGroupButtonTitle" icon="sort"
                (onClicked)="zoomParametersViewModel.toggleSortingGroups()"></nts-text-button>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- Clear filters command -->
      <div class="horizontal-flex-container-item-layout">
        <div class="command-bar-button-container">
          <nts-text-button [title]="zoomParametersViewModel.clearCommand.tooltip"
            [label]="zoomParametersViewModel.clearCommand.displayName"
            [isDisabled]="!(zoomParametersViewModel.clearCommand.canExecute$ | async)"
          (onClicked)="zoomParametersViewModel.clearCommand.execute()"></nts-text-button>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- Gestione comandi avanzati per la selezione dei campi -->
@if (zoomParametersViewModel.showSelectionsFilterOptions) {
  <div class="toolbar-section additional-toolbar">
    <div class="toolbar-control-content">
      <div class="horizontal-container">
        <div class="root-container">
          <div class="inline-command-bar">
            <div class="action-list-control-container">
              <div class="horizontal-flex-container">
                <div class="command-bar-button-container">
                  <nts-text-button
                    [title]="'std_CMD_SelectAll_Tooltip' | NTSTranslate"
                    [label]="'std_CMD_SelectAll_DisplayName' | NTSTranslate" [icon]="'add-selection'"
                    (onClicked)="zoomParametersViewModel.selectAll()">
                  </nts-text-button>
                </div>
                <div class="command-bar-button-container">
                  <nts-text-button
                    [title]="'std_CMD_DeselectAll_Tooltip' | NTSTranslate"
                    [label]="'std_CMD_DeselectAll_DisplayName' | NTSTranslate" [icon]="'remove-selection'"
                    (onClicked)="zoomParametersViewModel.deselectAll()">
                  </nts-text-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
<!-- Fine Gestione comandi avanzati per la selezione dei campi -->

<div class="zoom-parameters-content zoom-parameter-content-desktop"
  [class.is-hidden]="zoomParametersViewModel.showSortingGroups"
  [class.has-additional-toolbar]="zoomParametersViewModel.showSelectionsFilterOptions">
  <div #parameterLabels class="parameter-column parameter-column-labels">
    <!-- <div class="zoom-parameter-label">{{ zoomParametersViewModel.headerPropertyName }}</div> -->
    @for (filterVm of (zoomParametersViewModel.filters | zoomAvailablesFilter: zoomParametersViewModel.showFilterWithPopulatedOperator); track filterVm) {
      <div
        class="zoom-filter-name level-{{filterVm.metaData.level}}">
        <div class="zoom-filter-name-container">
          @if (zoomParametersViewModel.showSelectionsFilterOptions) {
            <nts-base-checkbox-text-box
              (onChange)="zoomParametersViewModel.notifyModified()"
              [(checkStatus)]="filterVm.isSelected"
              [label]="filterVm.propertyNameMap.displayName"
              [isDisabled]="!filterVm.isSelectable">
            </nts-base-checkbox-text-box>
          }
          <nts-label-box (click)="findExternal($event, filterVm)"
            [class.label-multiline]="filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.Between"
            [class.zoom-label]="filterVm.externalDomainModelNameToZoom !== '' && filterVm.islocked === false"
            [title]="filterVm.propertyNameMap.displayName"
          [label]="filterVm.propertyNameMap.displayName"></nts-label-box>
          @if (filterVm.isOperatorSupported | async) {
            @if (filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.In && isEnumZoomFilterViewModel(filterVm)) {
              <div class="white-space-container"
                >
                @for (filterIn of filterVm.filterValues; track filterIn) {
                  <div class="white-space"></div>
                }
              </div>
            }
            @if (filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.In && isExternalZoomFilterViewModel(filterVm)) {
              <div class="white-space-container"
                >
                @for (filterIn of filterVm.filterValues; track filterIn) {
                  <div class="white-space"></div>
                }
              </div>
            }
            @if (filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.Between) {
              <div class="white-space-container"
                >
                <div class="white-space"></div>
                <div class="white-space"></div>
              </div>
            }
            @if (filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.In && isDateTimeZoomFilterViewModel(filterVm)) {
              <div class="white-space-container"
                >
                @for (filterIn of filterVm.filterDateTimeValues; track filterIn) {
                  <div class="white-space"></div>
                }
              </div>
            }
          }
        </div>
        <div class="zoom-filter-action-container">
          @if (filterVm.externalDomainModelNameToZoom !== '' && filterVm.islocked === false) {
            <nts-text-button
              [icon]="(filterVm.isLoading$ | async) ? 'refresh-animated' : 'search'"
              (onClicked)="findExternal($event, filterVm)">
            </nts-text-button>
          }
          @if (isExpandableFilter(filterVm) && !zoomParametersViewModel.showFilterWithPopulatedOperator && filterVm.islocked == false) {
            <nts-text-button
              [title]="((filterVm.isCollapsed$ | async) ? 'std_ExpandableShowMore_Description' : 'std_ExpandableShowLess_Description') | NTSTranslate"
              [icon]="(filterVm.isCollapsed$ | async) ? 'eye-alt' : 'eye-close'"
              (onClicked)="toggleExpandableFilter(filterVm)">
            </nts-text-button>
          }
        </div>
      </div>
    }
  </div>

  <div #parameterOperators class="parameter-column parameter-column-operators">
    @for (filterVm of (zoomParametersViewModel.filters | zoomAvailablesFilter: zoomParametersViewModel.showFilterWithPopulatedOperator); track filterVm) {
      <div
        class="filter-operator">
        <nts-zoom-filter-operator-text-box [operator]="filterVm.operator"></nts-zoom-filter-operator-text-box>
        @if (filterVm.isOperatorSupported | async) {
          @if (filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.In && (isDateTimeZoomFilterViewModel(filterVm))) {
            @for (filterIn of filterVm.filterDateTimeValues | slice:0:-1; track filterIn) {
              <div class="white-space"></div>
            }
          }
          @if (filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.In && isEnumZoomFilterViewModel(filterVm)) {
            @for (filterIn of filterVm.filterValues | slice:0:-1; track filterIn) {
              <div class="white-space"></div>
            }
          }
          @if (filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.In && isExternalZoomFilterViewModel(filterVm)) {
            @for (filterIn of filterVm.filterValues | slice:0:-1; track filterIn) {
              <div class="white-space"></div>
            }
          }
          @if (filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.Between) {
            <div class="white-space"></div>
          }
        }
      </div>
    }
  </div>

  <div #parameterValues class="parameter-column parameter-values">
    @for (filterVm of (zoomParametersViewModel.filters | zoomAvailablesFilter: zoomParametersViewModel.showFilterWithPopulatedOperator); track filterVm) {
      <div
        class="filter-value-container"
        [class.filter-value-between]="filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.Between">
        @if (!(filterVm.isOperatorSupported | async)) {
          <div class="filter-value" #filters>
            @if (!filterVm.showVariables) {
              <div class="filter-value-list" @openClose>
                <div class="unsupported-operator">Operatore non supportato</div>
              </div>
            }
          </div>
        }
        @if (filterVm.isOperatorSupported | async) {
          @if (filterVm.operator.currentValue != zoomParametersViewModel.filterOperators.In) {
            <div class="filter-value"
              #filters
              [ngClass]="{'advanced-filters-show': zoomParametersViewModel.showAdvancedFiltersOptions }">
              @if (!filterVm.showVariables) {
                <div class="filter-value-list" @openClose>
                  @if (isFilterString(filterVm.filterValue) && !filterVm.showVariables) {
                    @if (isStringZoomFilterViewModel(filterVm)) {
                      <nts-zoom-filter-string-text-box
                        [filter]="filterVm"
                        [propertyViewModel]="filterVm.filterValue" (focus)="parameterFocus($event, filterVm)"
                        (keyDown)="keyDown($event)">
                      </nts-zoom-filter-string-text-box>
                    }
                  }
                  @if (isFilterGuid(filterVm.filterValue) && !filterVm.showVariables) {
                    @if (isGuidZoomFilterViewModel(filterVm)) {
                      <nts-zoom-filter-string-text-box
                        [filter]="filterVm"
                        [validateChipsFunc]="guidMaskSettings.validateMaskOnBlurFunc"
                        [maskSettings]="guidMaskSettings"
                        [propertyViewModel]="filterVm.filterValue" (focus)="parameterFocus($event, filterVm)"
                        (keyDown)="keyDown($event)">
                      </nts-zoom-filter-string-text-box>
                    }
                  }
                  @if (isFilterNumeric(filterVm.filterValue) && !filterVm.showVariables) {
                    @if (isNumericZoomFilterViewModel(filterVm)) {
                      <nts-zoom-filter-numeric-text-box
                        [filter]="filterVm"
                        [propertyViewModel]="filterVm.filterValue" [updateOnBlur]="true"
                        (focus)="parameterFocus($event, filterVm)"
                        (keyDown)="keyDown($event)">
                      </nts-zoom-filter-numeric-text-box>
                    }
                  }
                  @if (isFilterExternal(filterVm.filterValue) && !filterVm.showVariables) {
                    @if (isExternalZoomFilterViewModel(filterVm)) {
                      <nts-zoom-filter-external-text-box
                        [filter]="filterVm"
                        [propertyViewModel]="filterVm.filterValue" [updateOnBlur]="true"
                        (focus)="parameterFocus($event, filterVm)"
                        (keyDown)="keyDown($event)">
                      </nts-zoom-filter-external-text-box>
                    }
                  }
                  @if (isFilterBool(filterVm.filterValue) && !filterVm.showVariables) {
                    @if (isBoolZoomFilterViewModel(filterVm)) {
                      <nts-zoom-filter-bool-text-box
                        [filter]="filterVm"
                        [propertyViewModel]="filterVm.filterValue">
                      </nts-zoom-filter-bool-text-box>
                    }
                  }
                  @if (isFilterDate(filterVm.filterValue) && !filterVm.showVariables) {
                    @if (isDateTimeZoomFilterViewModel(filterVm)) {
                      <nts-zoom-filter-date-text-box
                        [filter]="filterVm"
                        [propertyViewModel]="filterVm.filterValue">
                      </nts-zoom-filter-date-text-box>
                    }
                  }
                  @if (isFilterDateTimeOffset(filterVm.filterValue) && !filterVm.showVariables) {
                    @if (isDateTimeZoomFilterViewModel(filterVm)) {
                      <nts-zoom-filter-date-offset-text-box
                        [filter]="filterVm"
                        [propertyViewModel]="filterVm.filterValue">
                      </nts-zoom-filter-date-offset-text-box>
                    }
                  }
                  @if (isFilterEnum(filterVm.filterValue) && !filterVm.showVariables) {
                    @if (isEnumZoomFilterViewModel(filterVm)) {
                      <nts-zoom-filter-enum-text-box
                        [filter]="filterVm"
                        [propertyViewModel]="filterVm.filterValue">
                      </nts-zoom-filter-enum-text-box>
                    }
                  }
                </div>
              }
              @if (filterVm.showVariables) {
                <div class="variables-container" @openClose>
                  @if (filterVm.showVariables) {
                    <nts-base-enum-text-box [value]="filterVm.filterVariableValue"
                      optionLabel="description"
                      dataKey="key" [options$]="filterVm.filterVariables$" [appendTo]="'body'"
                      [isDisabled]="filterVm.OperatorDoesNotRequireValue"
                      [placeholder]="zoomParametersViewModel.variablesPlaceholderTitle"
                      (onChange)="zoomParametersViewModel.onFilterVariableChange($event, filterVm)"
                      (onBlur)="zoomParametersViewModel.onFilterVariableBlur(filterVm)" [isNullable]="true">
                    </nts-base-enum-text-box>
                  }
                </div>
              }
              <!-- <div class="add-in-button-container" *ngIf="filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.In">
              <nts-text-button
                [title]="zoomParametersViewModel.addInFieldButtonTitle" [icon]="'plus'"
                (onClicked)="zoomParametersViewModel.addInField(filterVm)">
              </nts-text-button>
            </div> -->
            @if (zoomParametersViewModel.showAdvancedFiltersOptions && (filterVm.filterVariables$ | async)?.length > 0) {
              <div class="variables-button-container"
                >
                @if (zoomParametersViewModel.showAdvancedFiltersOptions) {
                  <nts-text-button
                    [title]="zoomParametersViewModel.variablesButtonTitle" [icon]="'filter'"
                    [class.var-visible]="filterVm.showVariables"
                    (onClicked)="zoomParametersViewModel.toogleVariablesVisibility(filterVm)">
                  </nts-text-button>
                }
              </div>
            }
          </div>
        }
        <!-- Between -->
        @if (filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.Between) {
          <div class="filter-value"
            #filters
            [ngClass]="{'advanced-filters-show': zoomParametersViewModel.showAdvancedFiltersOptions, 'filter-value-between':filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.Between }">
            @if (!filterVm.showVariables2) {
              <div class="filter-value-list" @openClose>
                @if (isFilterString(filterVm.filterValue) && !filterVm.showVariables2 && isFilterString(filterVm.filterValue2)) {
                  @if (isStringZoomFilterViewModel(filterVm)) {
                    <nts-zoom-filter-string-text-box [filter]="filterVm" [propertyViewModel]="filterVm.filterValue2"
                      [updateOnBlur]="true"
                      (focus)="parameterFocus($event, filterVm)" (keyDown)="keyDown($event)"
                      [ngClass]="'filter-value-text-between'">
                    </nts-zoom-filter-string-text-box>
                  }
                }
                @if (isFilterNumeric(filterVm.filterValue) && !filterVm.showVariables2 && isFilterNumeric(filterVm.filterValue2)) {
                  @if (isNumericZoomFilterViewModel(filterVm)) {
                    <nts-zoom-filter-numeric-text-box [filter]="filterVm" [propertyViewModel]="filterVm.filterValue2"
                      [updateOnBlur]="true"
                      (focus)="parameterFocus($event, filterVm)" (keyDown)="keyDown($event)"
                      [ngClass]="'filter-value-text-between'">
                    </nts-zoom-filter-numeric-text-box>
                  }
                }
                @if (isFilterExternal(filterVm.filterValue) && !filterVm.showVariables2 && isFilterExternal(filterVm.filterValue2)) {
                  @if (isExternalZoomFilterViewModel(filterVm)) {
                    <nts-zoom-filter-external-text-box [filter]="filterVm" [propertyViewModel]="filterVm.filterValue2"
                      (focus)="parameterFocus($event, filterVm)" (keyDown)="keyDown($event)" [updateOnBlur]="true">
                    </nts-zoom-filter-external-text-box>
                  }
                }
                @if (isFilterDate(filterVm.filterValue) && !filterVm.showVariables2 && isFilterDate(filterVm.filterValue2)) {
                  <nts-zoom-filter-date-text-box [propertyViewModel]="filterVm.filterValue2"
                    [ngClass]="'filter-value-text-between'">
                  </nts-zoom-filter-date-text-box>
                }
                @if (isFilterDateTimeOffset(filterVm.filterValue) && !filterVm.showVariables2 && isFilterDateTimeOffset(filterVm.filterValue2)) {
                  <nts-zoom-filter-date-offset-text-box [propertyViewModel]="filterVm.filterValue2"
                    [ngClass]="'filter-value-text-between'">
                  </nts-zoom-filter-date-offset-text-box>
                }
              </div>
            }
            @if (filterVm.showVariables2) {
              <div class="variables-container" @openClose>
                @if (filterVm.showVariables2 && filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.Between) {
                  <div class="mt-1"
                    @openClose>
                    @if (filterVm.showVariables2) {
                      <nts-base-enum-text-box [value]="filterVm.filterVariable2Value"
                        optionLabel="description" dataKey="key" [options$]="filterVm.filterVariables$" [appendTo]="'body'"
                        [isDisabled]="filterVm.OperatorDoesNotRequireValue"
                        [placeholder]="zoomParametersViewModel.variablesPlaceholderTitle"
                        (onChange)="zoomParametersViewModel.onFilterVariable2Change($event,filterVm)" [isNullable]="true"
                        (onBlur)="zoomParametersViewModel.onFilterVariable2Blur(filterVm)" [isNullable]="true">
                      </nts-base-enum-text-box>
                    }
                  </div>
                }
              </div>
            }
            @if (zoomParametersViewModel.showAdvancedFiltersOptions && (filterVm.filterVariables$ | async)?.length > 0) {
              <div class="variables-button-container"
                >
                @if (zoomParametersViewModel.showAdvancedFiltersOptions && filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.Between) {
                  <nts-text-button
                    [title]="zoomParametersViewModel.variablesButtonTitle" [icon]="'filter'"
                    [class.var-visible]="filterVm.showVariables2"
                    (onClicked)="zoomParametersViewModel.toogleVariables2Visibility(filterVm)">
                  </nts-text-button>
                }
              </div>
            }
          </div>
        }
        <!-- In -->
        @if (filterVm.operator.currentValue == zoomParametersViewModel.filterOperators.In) {
          <div class="filter-value"
            #filters>
            @if (!filterVm.showVariables) {
              <div class="filter-value-list" @openClose>
                @if (isFilterString(filterVm.filterValue) && !filterVm.showVariables) {
                  @if (isStringZoomFilterViewModel(filterVm)) {
                    <nts-zoom-filter-string-text-box
                      [filter]="filterVm"
                      [propertyViewModel]="filterVm.filterValue" (focus)="parameterFocus($event, filterVm)"
                      (keyDown)="keyDown($event)">
                    </nts-zoom-filter-string-text-box>
                  }
                }
                @if (isFilterNumeric(filterVm.filterValue) && !filterVm.showVariables) {
                  @if (isNumericZoomFilterViewModel(filterVm)) {
                    <nts-zoom-filter-numeric-text-box
                      [filter]="filterVm"
                      [propertyViewModel]="filterVm.filterValue" [updateOnBlur]="true"
                      (focus)="parameterFocus($event, filterVm)"
                      (keyDown)="keyDown($event)">
                    </nts-zoom-filter-numeric-text-box>
                  }
                }
                @if (isEnumZoomFilterViewModel(filterVm) && !filterVm.showVariables) {
                  @for (filterIn of filterVm.filterValues; track filterIn) {
                    <nts-zoom-filter-enum-text-box [propertyViewModel]="filterIn"
                      >
                    </nts-zoom-filter-enum-text-box>
                  }
                }
                @if (isExternalZoomFilterViewModel(filterVm) && !filterVm.showVariables) {
                  @for (filterIn of filterVm.filterValues; track filterIn) {
                    <nts-zoom-filter-external-text-box [filter]="filterVm"
                      [propertyViewModel]="getExternalZoomPropertyViewModel(filterIn)" (keyDown)="keyDown($event)"
                      [updateOnBlur]="true" (focus)="parameterFocus($event, filterVm)"
                      >
                    </nts-zoom-filter-external-text-box>
                  }
                }
                @if (isDateTimeZoomFilterViewModel(filterVm)) {
                  @if (isFilterDate(filterVm.filterValue) && !filterVm.showVariables) {
                    @for (filterIn of filterVm.filterDateTimeValues; track filterIn) {
                      <nts-zoom-filter-date-text-box [propertyViewModel]="getFilterDate(filterIn)"
                        [ngClass]="'filter-value-text-in'">
                      </nts-zoom-filter-date-text-box>
                    }
                  }
                  @if (isFilterDateTimeOffset(filterVm.filterValue) && !filterVm.showVariables) {
                    @for (filterIn of filterVm.filterDateTimeValues; track filterIn) {
                      <nts-zoom-filter-date-offset-text-box [propertyViewModel]="getFilterDateTimeOffset(filterIn)"
                        [ngClass]="'filter-value-text-in'">
                      </nts-zoom-filter-date-offset-text-box>
                    }
                  }
                }
              </div>
            }
            @if (isDateTimeZoomFilterViewModel(filterVm)) {
              <div class="in-buttons-container"
                >
                @for (filterIn of filterVm.filterDateTimeValues; track filterIn; let last = $last; let first = $first) {
                  <div class="filter-value-actions"
                    >
                    @if (last) {
                      <nts-text-button
                        [title]="zoomParametersViewModel.addInFieldButtonTitle" [icon]="'plus'"
                        (onClicked)="zoomParametersViewModel.addInField(filterVm)">
                      </nts-text-button>
                    }
                    @if (!first) {
                      <nts-text-button
                        [title]="zoomParametersViewModel.addInFieldButtonTitle" [icon]="'trash'"
                        (onClicked)="zoomParametersViewModel.deleteInField(filterVm, filterIn)">
                      </nts-text-button>
                    }
                  </div>
                }
              </div>
            }
            @if (isEnumZoomFilterViewModel(filterVm)) {
              <div class="in-buttons-container">
                @for (filterIn of filterVm.filterValues; track filterIn; let last = $last; let first = $first) {
                  <div class="filter-value-actions"
                    >
                    @if (last) {
                      <nts-text-button
                        [title]="zoomParametersViewModel.addInFieldButtonTitle" [icon]="'plus'"
                        (onClicked)="zoomParametersViewModel.addInField(filterVm)">
                      </nts-text-button>
                    }
                    @if (!first) {
                      <nts-text-button
                        [title]="zoomParametersViewModel.addInFieldButtonTitle" [icon]="'trash'"
                        (onClicked)="zoomParametersViewModel.deleteInField(filterVm, filterIn)">
                      </nts-text-button>
                    }
                  </div>
                }
              </div>
            }
            @if (isExternalZoomFilterViewModel(filterVm)) {
              <div class="in-buttons-container">
                @for (filterIn of filterVm.filterValues; track filterIn; let last = $last; let first = $first) {
                  <div class="filter-value-actions"
                    >
                    @if (last) {
                      <nts-text-button
                        [title]="zoomParametersViewModel.addInFieldButtonTitle" [icon]="'plus'"
                        (onClicked)="zoomParametersViewModel.addInField(filterVm)">
                      </nts-text-button>
                    }
                    @if (!first) {
                      <nts-text-button
                        [title]="zoomParametersViewModel.addInFieldButtonTitle" [icon]="'trash'"
                        (onClicked)="zoomParametersViewModel.deleteInField(filterVm, filterIn)">
                      </nts-text-button>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      }
    </div>
  }
</div>

</div>

@if (zoomParametersViewModel.filters) {
  <nts-zoom-parameters-sorting-groups
    [class.is-hidden]="!zoomParametersViewModel.showSortingGroups"
    [parameters]="zoomParametersViewModel"
    (onSortingGroupsChanged)="zoomParametersViewModel.notifyModified()">
  </nts-zoom-parameters-sorting-groups>
}